import React from "react"

import {Button, Typography} from "@mui/material"
import Grid from "@mui/material/Grid2"
import {useHistory} from "react-router-dom";
import {IntermediateCeilingGroundView} from "../../Plan/Verification/IntermediateCeilingGroundView";

const TitleGridItem = () => {
  const history = useHistory()

  return (
    <Grid size={12}>
      <Grid container justifyContent="space-between" alignItems="flex-end">
        <Grid>
          <Typography component="h1" variant="h4">
            {"Zwischendecke"}
          </Typography>
        </Grid>
        <Grid>
          <Button color="primary" onClick={() => history.push("/step/3")}>
            bearbeiten
          </Button>
        </Grid>
      </Grid>
      < hr/>
    </Grid>
  )
}

const PlanGridItem = () => {
  return (
    <Grid size={12}>
      <IntermediateCeilingGroundView/>
    </Grid>
  )
}

export const IntermediateCeilingGroundViewSection = () => {
  return (
    <Grid container spacing={4}>
      <TitleGridItem/>
      <PlanGridItem/>
    </Grid>
  )
}
